import { TeamsPage } from '../TeamsPage/TeamsPage'

export function OrgTeamsPage() {
  return <TeamsPage isOrg />
}
